import { Dropdown } from 'antd';
import React, { useState } from 'react';
import './LanguageSwitcher.css';
import GlobalStore from 'stores/globalStore';
import LanguageDropdown, { VIIcon, ENIcon } from './LanguageDropdown'

const LanguageSwitcher: React.FC = () => {
  const { currentLanguage } = GlobalStore.useContainer();
  const [visible, setVisible] = useState(false);

  const handleVisibleChange = (flag: boolean) => {
    setVisible(flag);
  };

  return (
    <Dropdown
      overlay={<LanguageDropdown />}
      onVisibleChange={handleVisibleChange}
      visible={visible}
    >
      <button className='current-language'>
        {currentLanguage === 'en' &&
          <ENIcon />
        }
        {currentLanguage === 'vi' &&
          <VIIcon />
        }
      </button>
    </Dropdown>
  )
}

export default LanguageSwitcher;
